import React, { useState, useEffect } from 'react';
import './OpenDoorCountdown.css';

function pluralizeLabel(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

function calcTimeLeft(targetMs: number) {
  const diff = targetMs - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, total: 0 };
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1_000);
  return { days, hours, minutes, seconds, total: diff };
}

interface OpenDoorCountdownProps {
  targetDate: string;
  onExpired?: () => void;
}

export const OpenDoorCountdown: React.FC<OpenDoorCountdownProps> = ({ targetDate, onExpired }) => {
  const [, setTick] = useState(0);
  const targetMs = new Date(targetDate).getTime();
  const timeLeft = calcTimeLeft(targetMs);

  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (timeLeft.total <= 0 && onExpired) onExpired();
  }, [timeLeft.total, onExpired]);

  const pad = (n: number) => String(n).padStart(2, '0');

  if (timeLeft.total <= 0) return null;

  return (
    <div className="opendoor-countdown-section">
      <h3 className="opendoor-countdown-title">До старта продаж осталось:</h3>
      <div className="opendoor-countdown-box">
        <div className="opendoor-countdown-row">
          {timeLeft.days > 0 && (
            <div className="opendoor-countdown-days-wrap">
              <div className="opendoor-time-block">
                <span className="opendoor-time-value">{timeLeft.days}</span>
                <span className="opendoor-time-label">
                  {pluralizeLabel(timeLeft.days, 'день', 'дня', 'дней')}
                </span>
              </div>
            </div>
          )}
          <div className="opendoor-time-block">
            <span className="opendoor-time-value">{pad(timeLeft.hours)}</span>
            <span className="opendoor-time-label">
              {pluralizeLabel(timeLeft.hours, 'час', 'часа', 'часов')}
            </span>
          </div>
          <span className="opendoor-time-sep">:</span>
          <div className="opendoor-time-block">
            <span className="opendoor-time-value">{pad(timeLeft.minutes)}</span>
            <span className="opendoor-time-label">
              {pluralizeLabel(timeLeft.minutes, 'минута', 'минуты', 'минут')}
            </span>
          </div>
          <span className="opendoor-time-sep">:</span>
          <div className="opendoor-time-block">
            <span className="opendoor-time-value">{pad(timeLeft.seconds)}</span>
            <span className="opendoor-time-label">
              {pluralizeLabel(timeLeft.seconds, 'секунда', 'секунды', 'секунд')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
